import '~/assets/dev/styles.scss';

jQuery(document).ready(function($) {

	setTimeout(function() {
        $('main, #alert-bar').addClass('is-ready');
    }, 100);

	let initMobileNavToggle = function() {
    $('.mobile-nav-toggle').on('click', function() {
        let mobileNavToggle = $('.mobile-nav-toggle');
        let mobileNavWrapper = $('#mobile-nav-wrapper');
        let mastheadHeight = $('#masthead').outerHeight();
        let viewportHeight = $(window).height(); // Get the height of the viewport
        let mobileNavWrapperHeight = viewportHeight - mastheadHeight;
        if (mobileNavToggle.hasClass('is--active')) {
            mobileNavToggle.removeClass('is--active');
            mobileNavWrapper.removeClass('is--active');
            $('body,html').css('overflow', 'auto');
            mobileNavWrapper.css('top', mastheadHeight + 'px');
            mobileNavWrapper.css('height', '');
            mobileNavWrapper.css('height', mobileNavWrapperHeight + 'px');
        } else {
            mobileNavToggle.addClass('is--active');
            mobileNavWrapper.addClass('is--active');
            $('body,html').css('overflow', 'hidden');

            mobileNavWrapper.css('top', mastheadHeight + 'px');
            mobileNavWrapper.css('height', mobileNavWrapperHeight + 'px');
        }
    });

    // Optional: Handle window resizing
    $(window).on('resize', function() {
        let mastheadHeight = $('#masthead').outerHeight();
        let viewportHeight = $(window).height();
        let mobileNavWrapperHeight = viewportHeight - mastheadHeight;
        $('#mobile-nav-wrapper').css('height', mobileNavWrapperHeight + 'px');
    });
	};

	initMobileNavToggle();

	let initMobileNavSubMenu = function() {
    // Handle clicks on menu items with children
    $('.mobile-navigation li.menu-item-has-children').on('click', function(event) {
        // Toggle class to show/hide submenu
        $(this).toggleClass('is--active');
        // Stop event from bubbling up
        event.stopPropagation();
    });

    // Prevent default action on anchor tags inside menu items with children
    $('.mobile-navigation li.menu-item-has-children > a').on('click', function(event) {
        event.preventDefault(); // Prevent default link behavior
    });
	};

	initMobileNavSubMenu();

	let addSectionIds = function() {
		$('.fcl').each(function(index) {
			$(this).attr('id', 'section-'+index);
		});
	}
	addSectionIds();

	let heroHeaderOffset = function() {
	    let mastheadHeight = $('#masthead').outerHeight();
	    let windowWidth = $(window).width();
	    let bodyHasClass = $('body').hasClass('blog') || $('body').hasClass('page-child') || $('body').hasClass('single');

	    if (bodyHasClass) {
	      
	    	$('#site-content').css('padding-top', mastheadHeight);
	        
	    } else {
	        // If the body does not have the specified classes
	        if (windowWidth <= 1024) {
	            // If the window width is less than or equal to 1024px, set padding-top to 0
	            $('#site-content').css('padding-top', mastheadHeight);
	        } else {
	            // If the window width is greater than 1024px, set padding-top to 0
	            $('#site-content').css('padding-top', 0);
	        }
	    }
	};

	// Call the function to apply the initial offset
	heroHeaderOffset();

	let initImageHeight = function() {
	    $('.img-height').each(function() {
	        var targetSection = $(this);
	        var imgElement = $(this).find('.section-bg-image img');

	        // Wait until the image is fully loaded
	        imgElement.on('load', function() {
	            var imgHeight = $(this).height();
	            targetSection.height(imgHeight);
	        });

	        // If the image is already loaded (e.g., from cache)
	        if (imgElement[0].complete) {
	            imgElement.trigger('load');
	        }
	    });
	}

	initImageHeight();

	// Function to animate stat numbers
	let animateStatNumbers = function() {
	    $('.stat-num').each(function() {
	        let $this = $(this);
	        let targetValue = parseInt($this.data('num'));
	        let startValue = parseInt($this.data('start')) || 0;
	        let duration = 2000; // total animation duration in milliseconds
	        let interval = 50; // update interval in milliseconds
	        let increment = Math.ceil((targetValue - startValue) / (duration / interval));
	        let currentValue = startValue;

	        let counter = setInterval(function() {
	            currentValue += increment;
	            if (currentValue >= targetValue) {
	                currentValue = targetValue;
	                clearInterval(counter);
	            }
	            $this.text(currentValue);
	        }, interval);
	    });
	};

	// Run animate on inview
	$('.single-stat-card, .single-stat-card-alt').on('inview', function(event, isInView) {
	    if (isInView && !$(this).hasClass('animation-complete')) {
	        animateStatNumbers();
	        $(this).addClass('animation-complete');
	    }
	});

	// animate text lines on inview
	$('.single-animated-line').on('inview', function(event, isInView) {
		if (isInView && !$(this).hasClass('animated-in')) {
	        $(this).addClass('animated-in');
	    }
	});

	let initCollabCarousel = function() {
	    $('.slick-collab-slider, .slick-content-slider').each(function() {
	        let slider = $(this);
	        let sliderWrapper = slider.closest('.fcl-copy-with-carousel');
	        
	        // Ensure that you are selecting a unique nav wrapper for each slider
	        let navWrapper = sliderWrapper.find('.slick-collab-slider-nav-wrapper .container .row .col-12');
	        
	        // Attach the event listener before initializing the slider
	        slider.on('init', function(event, slick) {
	            let totalSlides = slick.$slides.length; // Get total number of slides
	            let dotWidth = 100 / totalSlides; // Calculate width for each dot
	            
	            // Apply the width to each .slick-dots > li
	            $(slick.$dots).find('li').css('width', dotWidth + '%');
	        });

	        // Initialize the slider
	        slider.slick({
	            centerMode: true,
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            centerPadding: '27px',
	            variableWidth: true,
	            arrows: true,
	            dots: true,
	            infinite: true,
	            appendDots: navWrapper,  // Append dots to the unique nav wrapper
	            appendArrows: navWrapper, // Append arrows to the unique nav wrapper
	        });
	    });
	}

	initCollabCarousel();

	let initTestimonialSlider = function() {
		$('.slick-quote-slider').each(function() {
			let slider = $(this)
			let sliderWrapper = slider.closest('.fcl-large-testimonails');

			// Ensure that you are selecting a unique nav wrapper for each slider
	        let navWrapper = sliderWrapper.find('#quote-arrow-wrap');

	        // Initialize the slider
	        slider.slick({
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            autoplay:true,
	            variableWidth: false,
	            arrows: true,
	            dots: false,
	            infinite: true,
	            appendArrows: navWrapper, // Append arrows to the unique nav wrapper
	        });


		})
	}
	initTestimonialSlider();


	let initAccordion = function() {
		
		$('.single-accordion-item').on('click', function() {
			let accordionItem = $(this);
			accordionItem.toggleClass('is--open');
		});
	
	}
	initAccordion();

	let positionAlertBar = function() {
		if ($('#alert-bar').length > 0) {
			let alertBar = $('#alert-bar');
	
			if (alertBar.is(':visible') && !alertBar.hasClass('alert-bar-closed')) {
				$('body').addClass('alert-is-active');
			} else {
				$('body').removeClass('alert-is-active'); // Ensure the class is removed if not active
			}
	
			// Position the alert bar based on masthead height
			let mastheadHeight = $('#masthead').outerHeight();
			alertBar.css('top', mastheadHeight);
		}
	}
	positionAlertBar();



	let closeAlertBar = function() {
	    // Function to set a session cookie
	    function setCookie(name, value) {
	        document.cookie = `${name}=${value}; path=/;`;
	    }

	    // Function to get the value of a cookie
	    function getCookie(name) {
	        let value = `; ${document.cookie}`;
	        let parts = value.split(`; ${name}=`);
	        if (parts.length === 2) return parts.pop().split(';').shift();
	    }

	    // Check if the alert bar has already been closed
	    if (getCookie('alertBarClosed') !== 'true') {
	        if ($('#alert-bar').length > 0) {
	            $('.close-alert-bar').on('click', function() {
	                $('#alert-bar').addClass('alert-bar-closed');
	                $('body').removeClass('alert-is-active');
	                setCookie('alertBarClosed', 'true'); // Set the session cookie
	            });
	        }
	    } else {
	        $('#alert-bar').addClass('alert-bar-closed');
	        $('body').removeClass('alert-is-active'); // Hide the alert bar if cookie is set
	    }
	}

	closeAlertBar();



	// Focus styles for menus when using keyboard navigation
	// Properly update the ARIA states on focus (keyboard) and mouse over events
	$( '[role="menubar"]' ).on( 'focus.aria mouseenter.aria', '[aria-haspopup="true"]', function ( ev ) {
		$( ev.currentTarget ).attr( 'aria-expanded', true );
	});
	// Properly update the ARIA states on blur (keyboard) and mouse out events
	$( '[role="menubar"]' ).on( 'blur.aria mouseleave.aria', '[aria-haspopup="true"]', function ( ev ) {
		$( ev.currentTarget ).attr( 'aria-expanded', false );
	});

	$(window).on('load', function() {
		heroHeaderOffset();
		positionAlertBar();
	});

	var resizeTimer;

	$(window).on('resize', function(e) {

	  clearTimeout(resizeTimer);
	  resizeTimer = setTimeout(function() {
	  	initImageHeight();
	  	heroHeaderOffset();
	  	positionAlertBar();
	  }, 250);

	});

	// sticky masthead head
	 $(window).on('scroll', function() {
      var scrollTop = $(this).scrollTop();
      if (scrollTop > 75) {
        $('#masthead').addClass('is-stuck');
      } else {
        $('#masthead').removeClass('is-stuck');
      }
    });


});